import { getAuth } from "firebase/auth";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import GetSingleSchool from "../../../../Controllers/Admin/Schools/GetSingleSchool";
import UpdateSchool from "../../../../Controllers/Admin/Schools/UpdateSchool";
import CreateSchool from "../../../../Controllers/Admin/Schools/CreateSchool";
import { getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage";

export default function AddSchoolViewModel() {
  const navigate = useNavigate();
  let location = useLocation();

  const [AuthUser, setAuthUser] = useState();

  const [SchoolIDError, setSchoolIDError] = useState(false);
  const [InstitutionTypeError, setInstitutionTypeError] = useState(false);
  const [SchoolNameError, setSchoolNameError] = useState(false);
  const [HeadOfSchoolError, setHeadOfSchoolError] = useState(false);
  const [SchoolEmailError, setSchoolEmailError] = useState(false);
  const [SchoolUrlError, setSchoolUrlError] = useState(false);
  const [SchoolAddressError, setSchoolAddressError] = useState(false);
  const [SchoolStartDateError, setSchoolStartDateError] = useState(false);

  const [FormDisabled, setFormDisabled] = useState(false);
  const [IsUpdate, setIsUpdate] = useState(false);
  const [SchoolID, setSchoolID] = useState("");

  const [IsCheckError, setIsCheckError] = useState(false);
  const [AddSchool, setAddSchool] = useState({
    SchoolName: "",
    SchoolRegistrationNo: "",
    HeadOfSchool: "",
    SchoolStartDate: "",
    InstitutionType: "",
    SchoolEmail: "",
    SchoolWebsite: "",
    SchoolUrl: "",
    SchoolAddress: "",
    SchoolLogo: "",
  });

  useEffect(() => {
    const LocationArray = location.pathname.split("/");

    if (LocationArray[4] === "update") {
      // setIsCheckError(true);
      setIsUpdate(true);
      setSchoolID(LocationArray[5]);
      const fetchData = async () => {
        const SchoolData = await GetSingleSchool(SchoolID);
        setAddSchool({
          SchoolRegistrationNo: SchoolData?.SchoolRegistrationNo,
          SchoolName: SchoolData?.SchoolName,
          HeadOfSchool: SchoolData?.HeadOfSchool,
          SchoolStartDate: SchoolData?.SchoolStartDate,
          InstitutionType: SchoolData?.InstitutionType,
          SchoolEmail: SchoolData?.SchoolEmail,
          SchoolWebsite: SchoolData?.SchoolWebsite,
          SchoolUrl: SchoolData?.SchoolUrl,
          SchoolAddress: SchoolData?.SchoolAddress,
          SchoolLogo: SchoolData?.SchoolLogo,
        });
      };
      fetchData();
    } else {
    }
  }, [location.pathname, SchoolID]);

  useEffect(() => {
    async function fetchData() {
      getAuth().onAuthStateChanged(async (user) => {
        setAuthUser(user);
      });
    }
    fetchData();
  }, []);

  const UploadFile = async (file) => {
    const storage = getStorage();

    const __ext = file.name.split(".").pop();

    const path = `school_logo/${getAuth().currentUser.uid}/school.${__ext}`;

    const SchoolLogoRef = ref(storage, path);
    uploadBytes(SchoolLogoRef, file).then((snapshot) => {
      getDownloadURL(snapshot.ref).then((url) => {
        setAddSchool({
          ...AddSchool,
          SchoolLogo: url,
        });
      });
    });
  };
  // console.log(first)

  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }
  const UIErrorHandling = () => {
    let flag = 0;

    if (
      AddSchool.SchoolRegistrationNo === "" ||
      AddSchool.SchoolRegistrationNo === null ||
      AddSchool.SchoolRegistrationNo === undefined
    ) {
      setSchoolIDError(true);
      flag++;
    } else {
      setSchoolIDError(false);
    }

    if (
      AddSchool.SchoolName === "" ||
      AddSchool.SchoolName === null ||
      AddSchool.SchoolName === undefined ||
      AddSchool.SchoolName.length < 3
    ) {
      setSchoolNameError(true);
      flag++;
    } else {
      setSchoolNameError(false);
    }

    if (
      AddSchool.HeadOfSchool === "" ||
      AddSchool.HeadOfSchool === null ||
      AddSchool.HeadOfSchool === undefined ||
      AddSchool.HeadOfSchool.length < 3
    ) {
      setHeadOfSchoolError(true);
      flag++;
    } else {
      setHeadOfSchoolError(false);
    }

    if (
      AddSchool.SchoolStartDate === "" ||
      AddSchool.SchoolStartDate === null ||
      AddSchool.SchoolStartDate === undefined
    ) {
      setSchoolStartDateError(true);
      flag++;
    } else {
      setSchoolStartDateError(false);
    }
    if (
      AddSchool.InstitutionType === "" ||
      AddSchool.InstitutionType === null ||
      AddSchool.InstitutionType === undefined
    ) {
      setInstitutionTypeError(true);
      flag++;
    } else {
      setInstitutionTypeError(false);
    }

    if (!isValidEmail(AddSchool.SchoolEmail)) {
      setSchoolEmailError(true);
      flag++;
    } else {
      setSchoolEmailError(false);
    }
    if (
      AddSchool.SchoolUrl === "" ||
      AddSchool.SchoolUrl === null ||
      AddSchool.SchoolUrl === undefined
    ) {
      setSchoolUrlError(true);
      flag++;
    } else {
      setSchoolUrlError(false);
    }
    if (
      AddSchool.SchoolAddress === "" ||
      AddSchool.SchoolAddress === null ||
      AddSchool.SchoolAddress === undefined
    ) {
      setSchoolAddressError(true);
      flag++;
    } else {
      setSchoolAddressError(false);
    }

    return flag;
  };

  useEffect(() => {
    if (IsCheckError) UIErrorHandling();
  }, [
    IsCheckError,
    AddSchool.SchoolRegistrationNo,
    AddSchool.SchoolName,
    AddSchool.HeadOfSchool,
    AddSchool.SchoolStartDate,
    AddSchool.InstitutionType,
    AddSchool.SchoolEmail,
    AddSchool.SchoolWebsite,
    AddSchool.SchoolUrl,
    AddSchool.SchoolAddress,
    AddSchool.SchoolLogo,
  ]);

  const RegisterSchool = async () => {
    setIsCheckError(true);
    let flag = 0;
    flag = UIErrorHandling();
    if (flag === 0) {
      setFormDisabled(true);
      if (IsUpdate) {
        const SchoolFinalObject = {
          ...AddSchool,
        };

        await UpdateSchool(SchoolFinalObject, SchoolID)
          .then(() => {
            navigate("/user/admin/schools");
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        const SchoolFinalObject = {
          ...AddSchool,
        };
        await CreateSchool(SchoolFinalObject, AuthUser.uid)
          .then(() => {
            navigate("/user/admin/schools");
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } else {
      setFormDisabled(false);
    }
  };

  return {
    RegisterSchool,
    FormDisabled,
    AddSchool,
    setAddSchool,
    SchoolIDError,
    SchoolNameError,
    HeadOfSchoolError,
    SchoolStartDateError,
    InstitutionTypeError,
    SchoolEmailError,
    SchoolUrlError,
    UploadFile,
    SchoolAddressError,
    IsUpdate,
  };
}
